import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import AppShell from '../shell/AppShell';
import { UserContext } from '../../UserContext';
import UnifiedFamily from './UnifiedFamily';
import '../../features/brand/cwm-tokens.css';

/**
 * /unified/family-management — standalone route for the Family panel that
 * also lives as a tab on the dashboard. Waits for the session so the panel
 * doesn't flash an empty family before the user id is known.
 */
export default function UnifiedFamilyManagement() {
  const { userId, isInitialized } = useContext(UserContext);
  return (
    <AppShell backdrop>
      <div style={{ maxWidth: 1080, margin: '0 auto', padding: '28px 20px 4px', position: 'relative', zIndex: 1 }}>
        <motion.section
          initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.46, ease: [0.22, 1, 0.36, 1] }}
          style={{ textAlign: 'center', marginBottom: 8 }}
        >
          <div className="cwm-eyebrow-badge" style={{ marginBottom: 12 }}>FAMILY</div>
          <h1 style={{ fontSize: 36, fontWeight: 900, letterSpacing: '-0.025em', color: 'var(--cwm-ink)', margin: '0 0 8px' }}>
            Everyone at <em style={{ fontStyle: 'italic', color: 'var(--cwm-blue-deep)' }}>your table</em>.
          </h1>
          <p style={{ maxWidth: 560, margin: '0 auto', fontSize: 15, fontWeight: 500, color: 'var(--cwm-gray-700)' }}>
            Add the people you order for and their allergies. Turn on Family Mode and chat checks every dish for all of them.
          </p>
        </motion.section>
      </div>
      <div style={{ maxWidth: 1080, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {isInitialized && <UnifiedFamily userId={userId} />}
      </div>
    </AppShell>
  );
}
